import { jwtDecode } from 'jwt-decode';
import { Injectable } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly SESSION_TOKEN_KEY = 'session_token';

    constructor(private _tokenService: TokenService) {}

    validateAndStoreTokenAndDecode(token?: any): any {
        if (!token) {
            token = this._tokenService.getToken(this.SESSION_TOKEN_KEY);
        }

        try {
            const decodedToken: any = jwtDecode(token);

            const currentTime = Math.floor(Date.now() / 1000);
            if (decodedToken.exp && decodedToken.exp < currentTime) {
                this._tokenService.clearToken(this.SESSION_TOKEN_KEY);
                localStorage.clear();
                return false;
            }

            this._tokenService.setToken(this.SESSION_TOKEN_KEY, token);
            return decodedToken;
        } catch (error) {
            return false;
        }
    }

    clearToken() {
        this._tokenService.clearToken(this.SESSION_TOKEN_KEY);
    }
}
